import React from "react";
import OutreachSnapshotCard from "../../components/ai/OutreachSnapshotCard";
import ProposedActionsCard from "../../components/ai/ProposedActionsCard";
import RevivalHeader from "../../components/Revival/RevivalHeader";
import "../../components/ai/ProposedActionsCard.css";
import "../../components/Revival/revival.css";
import "./sales-ds.css";

// AI Revival — the review surface for AI-proposed win-back actions.
// The brain proposes → owner reviews evidence → approves → the executor runs
// (sends stay sandboxed until AI_WINBACK_LIVE_SENDS is flipped). Content is
// driven by GET /api/analytics/proposed-actions/; ProposedActionsCard renders
// an honest empty/error state until the backend + engine are live.
export default function AiRevival() {
  return (
    <div className="rv-screen">
      <RevivalHeader title="AI Revival" />
      <p className="rv-note">
        AI-proposed win-back actions, ranked by cited evidence. Review the evidence and approve to queue; nothing sends while win-back is sandboxed.
      </p>
      <OutreachSnapshotCard />
      <ProposedActionsCard />
    </div>
  );
}
